export function centerOf(grid, col, row) {
	return { x: grid.offset_x + (col + 0.5) * grid.cell_w, y: grid.offset_y + (row + 0.5) * grid.cell_h };
}

export function cellAt(grid, x, y) {
	return { col: Math.floor((x - grid.offset_x) / grid.cell_w), row: Math.floor((y - grid.offset_y) / grid.cell_h) };
}

export function cellPolygon(grid, col, row) {
	const left = grid.offset_x + col * grid.cell_w;
	const top = grid.offset_y + row * grid.cell_h;
	const right = left + grid.cell_w;
	const bottom = top + grid.cell_h;
	return [left, top, right, top, right, bottom, left, bottom];
}

export function visibleCells(grid, rect) {
	const first = cellAt(grid, rect.x, rect.y);
	const last = cellAt(grid, rect.x + rect.width, rect.y + rect.height);
	const cells = [];
	for (let col = first.col; col <= last.col; col++) {
		for (let row = first.row; row <= last.row; row++) cells.push({ col, row });
	}
	return cells;
}

// Diagonal steps count as one cell (Chebyshev), the usual table convention for
// square maps.
export function distance(_grid, from, to) {
	return Math.max(Math.abs(to.col - from.col), Math.abs(to.row - from.row));
}
